import React, { useEffect, useState } from "react";
import classes from "./Trails.module.scss";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFlag,
  faCheck,
  faExclamationTriangle,
  faMapMarkerAlt,
  faBookmark,
} from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

interface _Trails {
  game_list: any;
}

export default function Trails({ game_list }: _Trails) {
  const { t } = useTranslation();
  const [_content, setContent] = useState<any>(<></>);

  function getTrails(trails: any) {
    const _trails = new Array(0);
    // console.log("trails");
    // console.log(trails);
    _trails.push(
      <div
        className={
          classes.wrapper + " " + classes.option_1 + " " + classes.option_1_1
        }
      >
        <div className="row">
          <h3 className={classes.traislTitle}>
            {t("trilhas.trail") + " " + t("trilhas." + trails.label)}
          </h3>
          {/* <span className={classes.traislDesc}>
          {getTrailPosition(trails)} / {trails.all_progress.length} Etapas
        </span> */}
        </div>

        <div className="row">
          <ol className={classes.vStepper}>{getSteps(trails)}</ol>
        </div>
      </div>
    );

    return _trails;
  }

  function getTrailPosition(steps: any) {
    let progress = 0;
    steps.all_progress.forEach((item: any, index: number) => {
      if (Number(steps.progress) == index) {
        progress = Number(steps.progress) + 1;
      }
    });
    return progress;
  }

  function getTrailStatus(item: any, index: number) {
    if ((index + 1) % 5 == 0) {
      return "Checkpoint";
    }
    if (item.lifes in item.jump_games) {
      const hasJumpGames = item.jump_games[item.lifes].filter(
        (element: any) => {
          return element == index;
        }
      );
      if (hasJumpGames.length > 0) {
        return "Pulou a Etapa";
      }
    }

    if (Number(item.progress) == index) {
      return "Etapa Atual";
    } else if (item.progress > index) {
      return "Etapa Concluída";
    } else {
      return "Etapa Bloqueada";
    }
  }

  function getSteps(steps: any) {
    const _steps = new Array(0);
    steps.all_progress.forEach((item: any, index: number) =>
      _steps.push(
        <li
          className={getTrailClass(steps, index)}
          key={index}
          id={classes.step}
          style={{ animationDelay: (index * 0.1).toString() + "s" }}
        >
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <div id="button-tooltip" className={classes.tooltip}>
                {getTrailStatus(steps, index)}
              </div>
            }
          >
            <FontAwesomeIcon
              className={classes.vStepper__icon}
              icon={getIcon(steps, index)}
              size="lg"
            />
          </OverlayTrigger>
          <div className={classes.vStepper__desc_etapa}>
            <p>Etapa {index + 1}</p>
            {(index + 1) % 5 == 0 && <span id="_checkpoint">(Checkpoint)</span>}
          </div>

          {getTrailPosition(steps) > index && (
            <>
              <span className={classes.vStepper__title}>{item.name}</span>
              <p className={classes.vStepper__desc}>Nível {item.nivel}</p>
            </>
          )}
        </li>
      )
    );

    return _steps;
  }

  function inRange(index: number, progress: number, maxSize: number) {
    const middle = 5;

    if (Math.abs(index - progress) <= middle / 2) {
      return true;
    } else if (progress <= 1 && index < middle) {
      return true;
    } else if (progress == maxSize - 1 && index > progress - middle) {
      return true;
    } else {
      return false;
    }
    // else if (index < progress) {
    //   return classes.hideStepAnim
    // }
  }
  function getIcon(item: any, index: number) {
    if ((index + 1) % 5 == 0) {
      return faBookmark;
    }
    if (item.lifes in item.jump_games) {
      const hasJumpGames = item.jump_games[item.lifes].filter(
        (element: any) => {
          return element == index;
        }
      );
      if (hasJumpGames.length > 0) {
        return faExclamationTriangle;
      }
    }

    if (Number(item.progress) == index) {
      return faMapMarkerAlt;
    } else if (item.progress > index) {
      return faCheck;
    } else {
      return faFlag;
    }
  }

  function getTrailClass(item: any, index: number) {
    let customClass = classes.hideStep;
    const _returnClass = inRange(
      index,
      Number(item.progress),
      item.all_progress.length
    );

    if (typeof _returnClass === "string") {
      customClass = _returnClass;
    } else if (_returnClass) {
      customClass = "";
    }

    // if (inRange(index, Number(item.progress), item.all_progress.length)) {
    //   customClass = "";
    // }
    if ((index + 1) % 5 == 0) {
      customClass = classes._checkpoint + " " + customClass;
    }

    if (item.lifes in item.jump_games) {
      const hasJumpGames = item.jump_games[item.lifes].filter(
        (element: any) => {
          return element == index;
        }
      );
      if (hasJumpGames.length > 0) {
        return (
          classes.vStepper__item +
          " " +
          classes.vStepper__item_jump +
          " " +
          customClass
        );
      }
    }

    if (Number(item.progress) == index) {
      return (
        classes.vStepper__item +
        " " +
        classes.vStepper__item_active +
        " " +
        customClass
      );
    } else if (item.progress > index) {
      return (
        classes.vStepper__item +
        " " +
        classes.vStepper__item_completed +
        " " +
        customClass
      );
    } else {
      return (
        classes.vStepper__item +
        " " +
        classes.vStepper__item_deactive +
        " " +
        customClass
      );
    }
  }
  useEffect(() => {
    if (game_list != null) {
      // console.log(game_list);
      setContent(getTrails(game_list));
    }
  }, [game_list]);

  return _content;
}
